import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Box, Alert, AlertTitle } from "@mui/material";
import { config } from "src/configs/constants";

const POLL_INTERVAL = 10000;

function BackendDownAlert() {
  const [isDown, setIsDown] = useState(false);
  const pollRef = useRef(null);

  useEffect(() => {
    const stopPolling = () => {
      clearInterval(pollRef.current);
      pollRef.current = null;
    };

    const checkBackend = async () => {
      try {
        const resp = await axios.get(config.url.API_URL);
        if (resp.status === 200) {
          setIsDown(false);
          stopPolling();
        }
      } catch (_) {
        // continua fora do ar, próxima tentativa no próximo tick
      }
    };

    const onDown = () => {
      setIsDown(true);
      if (!pollRef.current) {
        pollRef.current = setInterval(checkBackend, POLL_INTERVAL);
      }
    };
    const onUp = () => {
      setIsDown(false);
      stopPolling();
    };

    window.addEventListener("backend:down", onDown);
    window.addEventListener("backend:up", onUp);

    return () => {
      window.removeEventListener("backend:down", onDown);
      window.removeEventListener("backend:up", onUp);
      stopPolling();
    };
  }, []);

  if (!isDown) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 9999,
        maxWidth: 400,
        width: "calc(100vw - 32px)",
      }}
    >
      <Alert
        severity="warning"
        sx={{
          boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
          backgroundColor: "rgba(32, 31, 31, 0.97)",
          color: "#b1ac9d",
          "& .MuiAlert-icon": { color: "#ffb74d" },
          "& .MuiAlertTitle-root": { color: "#b1ac9d" },
        }}
      >
        <AlertTitle sx={{ fontWeight: 700 }}>Atualização em andamento</AlertTitle>
        Nossos servidores estão atualizando no momento, espere alguns minutos e
        atualize a sua página.
      </Alert>
    </Box>
  );
}

export default BackendDownAlert;
